<!--
 * @Author: YuanYuan
 * @Date: 2024-02-27 10:28:49
 * @LastEditTime: 2025-04-30 14:56:30
 * @description: 启用禁用，开启关闭带彩色dot
-->
<template>
  <span>
    <span v-if="dot" :class="dotClazz" class="status-dot"></span>
    <span :class="textHighlight?textClazz:''">
      <slot>{{ text }}</slot>
    </span>
  </span>
</template>

<script setup>
import { computed, toRefs } from 'vue'
import { constGet } from '@/utils/base'

const props = defineProps({
  value: {
    type: [Number, String],
    default: ''
  },
  dot: {
    type: Boolean,
    default: true
  },
  type: {
    type: String,
    default: 'success'
  },
  // 可以传入状态列表的const路径，此时type失效
  constPath: {
    type: String,
    default: ''
  },
  textHighlight: {
    type: Boolean,
    default: false
  }
})

const { dot, constPath, type, value, textHighlight } = toRefs(props)

const dotClazz = computed(() => {
  if (constPath.value) {
    return constGet(constPath.value, value.value, 'bgClazz')
  } else {
    return `bg-color-${type.value}`
  }
})

const textClazz = computed(() => {
  if (constPath.value) {
    return constGet(constPath.value, value.value, 'colorClazz')
  } else {
    return `text-color-${type.value}`
  }
})

const text = computed(() => {
  if (constPath.value) {
    return constGet(constPath.value, value.value)
  } else {
    return ''
  }
})

</script>

<style lang="scss" scoped>
.status-dot{
  display: inline-block;
  width: 4px;
  height: 4px;
  border-radius: 100%;
  margin-right: 4px;
  vertical-align: middle;
}
</style>
